module.exports = __webpack_public_path__ + "static/11-283d2ac1664d78d27e7c7951f399c70a.jpg";